export default "__VITE_ASSET__D6LRZPU2__"